import BookRating from './BookRating';
export default BookRating;
